import { VoicePlatform, VoiceType } from "hooks/__generated__/useTtsVoicesQuery.graphql";

// Current pricing as of March 2024
export const getTtsCostPer1kChars = (platform: VoicePlatform, type: VoiceType): number => {
  switch (platform) {
    case "openai":
      return 0.015; // OpenAI tts-1 model
    case "google":
      return type === "Neural" ? 0.016 : 0.004; // Neural: $16/1M chars, Standard: $4/1M chars
    case "azure":
      return 0.016; // Both Standard and Neural voices
    default:
      return 0.016; // Default to Azure pricing as fallback
  }
};

export const calculateTtsCost = (text: string, platform: VoicePlatform, type: VoiceType): number => {
  const chars = text.length;
  const costPer1kChars = getTtsCostPer1kChars(platform, type);
  return (chars / 1000) * costPer1kChars;
};
